import * as actionTypes from '../Register_action.types';

const initialState = {
  loggingIn: false,
  clients: [],
  error: null,
  message: '',
};
const AttendanceRegisterOverrideReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPLOAD_ATTENDANCE_OVERRIDE_REQUEST:
    case actionTypes.GET_ATTENDANCE_OVERRIDE_REQUEST:
    case actionTypes.MULTIDELETE_ATTENDANCE_OVERRIDE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.UPLOAD_ATTENDANCE_OVERRIDE_SUCCESS:
    case actionTypes.GET_ATTENDANCE_OVERRIDE_SUCCESS:
    case actionTypes.MULTIDELETE_ATTENDANCE_OVERRIDE_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };
    case actionTypes.GET_CTC_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        clients: action.payload,

      }


    case actionTypes.GET_CTC_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        clients: action.payload,
      };

    case actionTypes.UPLOAD_ATTENDANCE_OVERRIDE_FAILURE:
    case actionTypes.GET_ATTENDANCE_OVERRIDE_FAILURE:
    case actionTypes.MULTIDELETE_ATTENDANCE_OVERRIDE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default AttendanceRegisterOverrideReducer
